<template>
  <button
    :class="buttonClass"
    :style="buttonStyle"
    v-bind="$attrs"
    @click="handleClick"
    @mouseenter="handleCustomColorMouseEnter"
    @mouseleave="handleCustomColorMouseLeave"
  >
    <slot :style="{ ...((!solid || border) && { color }) }"></slot>
  </button>
</template>

<script>
export default {
  name: "RofixButton",
  props: {
    flat: Boolean,
    solid: {
      type: Boolean,
      default: true,
    },
    fillOnHover: Boolean,
    border: Boolean,
    color: String,
  },
  data() {
    return {
      isCustomColorHover: false,
    };
  },
  emits: ["click"],
  methods: {
    handleClick(e) {
      this.$emit("click", e);
    },

    handleCustomColorMouseEnter() {
      if (!this.color) return;
      if (this.solid && !this.border && !this.flat) return;
      if (!this.fillOnHover) return;

      this.isCustomColorHover = true;
    },

    handleCustomColorMouseLeave() {
      if (!this.color) return;
      if (this.solid && !this.border && !this.flat) return;
      if (!this.fillOnHover) return;

      this.isCustomColorHover = false;
    },
  },
  computed: {
    buttonClass() {
      return [
        "rofix-button",
        this.flat ? "flat" : "",
        this.border ? "border" : this.solid && !this.flat ? "solid" : "",
        this.fillOnHover ? "fill-on-hover" : "",
      ];
    },

    buttonStyle() {
      const { color, border, solid, isCustomColorHover } = this;
      return (
        color && {
          borderColor: color,
          ...(((solid && !border) || isCustomColorHover) && {
            backgroundColor: color,
          }),
          ...((!solid || border) && { color }),
        }
      );
    },
  },
};
</script>

<style>
.rofix-button {
  padding: 0.75rem 2rem;
  border-radius: 0;
  color: var(--rofix-primary);
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 600;
}

.rofix-button > * {
  color: inherit;
  fill: currentColor;
}

.rofix-button.flat {
  border: none;
}

.rofix-button:not(.flat) {
  border: 2px solid var(--rofix-primary);
}

.rofix-button:not(.solid).fill-on-hover:hover {
  color: white !important;
  fill: white !important;
}

.rofix-button:not(.solid) {
  background-color: transparent;
}

.rofix-button.solid {
  background-color: var(--rofix-primary);
  color: white;
}
</style>
